import 'bootstrap';

import { createRoot } from 'react-dom/client';

import App from 'app/App';
import { installTruncateTitle } from 'ui/truncateTitle';

installTruncateTitle();

createRoot(document.getElementById('root')!).render(<App />);
